import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    position: 'fixed',
    width: 560,
    height: 448,
    bottom: 24,
    right: 24,
    padding: 20,
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
    borderRadius: '2px',
    boxShadow: '0 24px 24px 0 rgba(0, 0, 0, 0.3), 0 0 24px 0 rgba(0, 0, 0, 0.22)',
    zIndex: 3,
  },
  subtitle: {
    position: 'absolute',
    top: 7,
    left: 0,
    fontSize: 14,
    fontWeight: 500,
    color: '#666',
    letterSpacing: 'normal',
  },
  // tableWrap: {
  //   border: '1px solid #dbdbdb',
  //   borderRadius: 3,
  //   height: 192,
  //   overflow: 'scroll',
  // },
  paginationToolbar: {
    minHeight: 36,
  },
  paginationIconButton: {
    padding: 6,
  },
  // contentRow: {
  //   height: 48,
  // },
  // contentDesc2: {
  //   fontSize: 11,
  //   color: '#aaa',
  //   lineHeight: 1.2,
  // },
  buttonWrap: {
    paddingTop: 20,
    marginRight: -4,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  detailWrap: {
    display: 'flex',
  },
  bigImageWrap: {
    marginRight: 24,
  },
  bigImage: {
    width: 200,
    height: 200,
    borderRadius: 6,
    objectFit: 'cover',
    overflow: 'hidden',
    border: 'solid 0.5px rgba(0, 0, 0, 0.06)',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
  detailContentWrap: {
    paddingTop: 8,
    flexDirection: 'column',
  },
  gridRow: {
    marginBottom: 13,
  },
  gridTitle: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 11,
    width: 74,
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.text.primary,
    opacity: 0.54,
    letterSpacing: 'normal',
  },
  gridContent: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    fontSize: 14,
    color: '#666',
    letterSpacing: 'normal',
  },
  gridUsername: {
    fontWeight: 500,
  },
  historiesWrap: {
    position: 'relative',
  },
  ///////////

  contentLink: {
    fontSize: 14,
    color: '#666',
    textDecoration: 'underline',
    fontWeight: 500,
  },

  contentWriter: {
    fontWeight: 500,
    fontSize: 14,
    color: theme.palette.primary.main,
    backgroundColor: `${theme.palette.primary.main.toString()}10`,
    paddingLeft: 3,
    paddingRight: 3,
  },
  personIcon: {
    fontSize: 16,
    color: '#666',
    verticalAlign: 'middle',
  },
  crownIcon: {
    display: 'inline-block',
    height: 16,
    verticalAlign: 'top',
    marginTop: 2,
    marginRight: 2,
  },
  reviewStatus: {
    textTransform: 'capitalize',
  },
  approve: {
    color: theme.palette.primary.main,
  },
  fatal: {
    color: '#d0021b',
  },
  historyItemsWrap: {
    padding: 8,
    backgroundColor: theme.palette.type === 'dark' ? '#f2f2f218' : '#f2f2f2',
    borderRadius: 8,
    height: 112,
    overflow: 'scroll',
  },
  historyItemsInnerWrap: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  historyItem: {
    width: 240,
    paddingRight: 8,
    marginBottom: 2,
    display: 'flex',
    alignItems: 'center',
  },
  smallImageWrap: {
    marginRight: 12,
  },
  smallImage: {
    width: 68,
    height: 68,
    borderRadius: 8,
    objectFit: 'cover',
    overflow: 'hidden',
    border: 'solid 0.5px rgba(0, 0, 0, 0.06)',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
  historyContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  dateTime: {
    fontSize: 12,
    color: '#666',
    letterSpacing: 'normal',
  },
}));

export default useStyles;
